import * as React from "react";
import clsx from "clsx";

interface Props {
  name: string;
  icon?: React.ReactNode;
  actions: React.ReactNode;
  children: React.ReactNode;
  headerClassName?: string;
}

export const InlineArtefactShell: React.FC<Props> = ({
  name,
  icon,
  actions,
  children,
  headerClassName = "bg-ivory-mist-50",
}) => (
  <div className="my-3 overflow-hidden rounded-lg border border-desert-sand-200">
    <div
      className={clsx("flex items-center justify-between border-b border-desert-sand-200 px-3 py-1.5", headerClassName)}
    >
      <div className="flex items-center gap-1.5">
        {icon}
        <span className="text-xs font-medium text-muted-foreground">{name}</span>
      </div>
      <div className="flex items-center gap-1">{actions}</div>
    </div>
    {children}
  </div>
);
